import { useEffect, useState } from 'react';
import { Incident } from '../types';

type AppIncident = {
  name: string;
  message: string;
  status: string;
  statuspageio_id: string | null;
  service: {
    key: string;
  };
};

const useGlobalIncidents = (implementationIds: string[]) => {
  const [data, setData] = useState<Incident[]>();

  useEffect(() => {
    let isMounted = true;

    fetch(
      'https://prometheus.zapier.com/api/v1/incidents/?resolved=false&hours=false'
    )
      .then(res => res.json())
      .then(incidents => {
        if (isMounted) {
          const appIncidents = (incidents as AppIncident[])
            .filter(({ service: { key } }) => implementationIds.includes(key))
            .map(
              ({
                name,
                message,
                status,
                statuspageio_id,
                service: { key },
              }) => ({
                name,
                body: message,
                status,
                shortlink:
                  statuspageio_id &&
                  `https://status.zapier.com/incidents/${statuspageio_id}`,
                iconApp: key,
              })
            );
          if (appIncidents.length > 0) {
            setData(appIncidents);
          }
        }
      });

    return () => {
      isMounted = false;
    };
  }, [implementationIds]);

  return {
    data,
  };
};

export default useGlobalIncidents;
